import { render } from "./UpdateUserDataVisibility.vue?vue&type=template&id=0adfc3d3&scoped=true"
import script from "./UpdateUserDataVisibility.vue?vue&type=script&lang=js"
export * from "./UpdateUserDataVisibility.vue?vue&type=script&lang=js"

import "./UpdateUserDataVisibility.vue?vue&type=style&index=0&id=0adfc3d3&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adfc3d3"]])

export default __exports__